// extracted by mini-css-extract-plugin
module.exports = {"icons":"budget_icons__FN3bR"};